export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14064.62c6bd99.jpg";